// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    width: 1200,
    margin: '0 auto',
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(10),
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3),
    borderBottom: '1px solid #E5E7EB',
  },
  filterSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  filterLabel: {
    color: '#374151',
    fontSize: '14px',
    fontWeight: 500,
  },
  periodSelect: {
    minWidth: 120,
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-select': {
      paddingLeft: 0,
      fontWeight: 500,
      color: '#111827',
    },
  },
  monthSelect: {
    minWidth: 160,
  },
  selectMenuProps: {
    PaperProps: {
      style: {
        maxHeight: 300,
      },
    },
  },
  yearSelect: {
    minWidth: 100,
  },
  dateRangeInputs: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  datePicker: {
    width: 130,
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: '8px 0',
      fontWeight: 500,
      color: '#111827',
    },
  },
  summaryCardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  summaryCard: {
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    padding: theme.spacing(3),
    backgroundColor: '#fff',
  },
  summaryValue: {
    fontSize: '24px',
    fontWeight: 500,
    color: '#111827',
    marginBottom: theme.spacing(1),
  },
  summaryLabel: {
    color: '#6B7280',
    fontSize: '14px',
  },
  balanceDifferenceChip: {
    marginTop: theme.spacing(1.5),
    fontWeight: 500,
  },
  periodActivityValues: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  creditValue: {
    fontSize: '24px',
    fontWeight: 500,
    color: '#2563EB',
    paddingRight: theme.spacing(2),
    borderRight: '1px solid #E5E7EB',
  },
  debitValue: {
    fontSize: '24px',
    fontWeight: 500,
    color: '#DC2626',
  },
  transactionSection: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  transactionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  exportButton: {
    backgroundColor: '#E5EAEE',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    borderRadius: '4px',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  exportButtonText: {
    color: '#021E40',
    fontWeight: 500,
  },
  tableContainer: {
    boxShadow: 'none',
  },
  tableHeaderCell: {
    fontWeight: 600,
    color: '#6B7280',
    fontSize: '12px',
    textTransform: 'uppercase' as const,
    borderBottom: '1px solid #E5E7EB',
    padding: theme.spacing(2),
  },
  tableCell: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #E5E7EB',
    color: '#374151',
  },
  tableCellBold: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #E5E7EB',
    color: '#111827',
    fontWeight: 600,
  },
  creditCell: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #E5E7EB',
    color: '#2563EB',
    fontWeight: 500,
  },
  debitCell: {
    padding: theme.spacing(2),
    borderBottom: '1px solid #E5E7EB',
    color: '#DC2626',
    fontWeight: 500,
  },
  noDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8),
    gap: theme.spacing(2),
  },
});

export default styles;
